export const action = {
  FEATURE_FLAGS_LOADING: 'FEATURE_FLAGS_LOADING',
  FEATURE_FLAGS_SUCCESS: 'FEATURE_FLAGS_SUCCESS',
  FEATURE_FLAGS_ERROR: 'FEATURE_FLAGS_ERROR',
};
